import { render, staticRenderFns } from "./TheSourceMenuGroup.vue?vue&type=template&id=f4db3586&scoped=true&"
import script from "./TheSourceMenuGroup.vue?vue&type=script&lang=js&"
export * from "./TheSourceMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceMenuGroup.vue?vue&type=style&index=0&id=f4db3586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4db3586",
  null
  
)

export default component.exports